module.exports = __webpack_public_path__ + "img/wave-shapes-right.045c3620.svg";